<template>
  <el-cascader
    v-model="selectedOptions"
    style="width: 100%"
    :options="options"
    :props="props"
  ></el-cascader>
</template>

<script>
export default {
  name: 'AreaSelect',
  components: {},
  props: {
    value: {
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      props: {
        value: 'areaCode',
        label: 'areaName',
        children: 'children'
      }
    }
  },
  computed: {
    selectedOptions: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    // this.getprovinces()
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      this.$store.dispatch('account/getcitytree', {
        payload: {},
        success: (res) => {
          this.options = res.data.areaNodes
        },
        fail: () => {
        }
      })
    }

  }
}
</script>
<style lang="stylus" scoped>
</style>
